<template>
	<div class="about-report">
		<div class="page-container">
			<PageTitle ch="利澤‧國際偶戲藝術村 交通資訊" en=""></PageTitle>
			<br />
			<br />
			<section class="traffic">
				<article class="message">
					<h1 class="row" align-y="center" gutter="10">
						<img
							src="@/assets/home/logo.png"
							style="width: 1.5em; display: inline"
						/>
						<span style="color: #062b51;font-weight: 700;">交通資訊</span>
					</h1>
					<div>
						<p style="margin-top: 10px">268015宜蘭縣五結鄉利澤東路37號　</p>
						<p>
							No. 37, Lize E. Road, Wujie Township, Yilan County, TAIWAN 26841
						</p>
						<p>Phone: ＋886-3-9501977</p>
						<!-- <a
							href="https://www.google.com/maps/place/%E5%88%A9%E6%BE%A4%E5%9C%8B%E9%9A%9B%E5%81%B6%E6%88%B2%E8%97%9D%E8%A1%93%E6%9D%91+Lize+Puppet+Art+Colony%EF%BC%88%E6%8E%A110%E4%BA%BA%E4%BB%A5%E4%B8%8A%E5%9C%98%E9%AB%94%E9%A0%90%E7%B4%84%E5%88%B6%EF%BC%89/@24.667744,121.823436,17z/data=!4m6!3m5!1s0x3467e8b2bf53c171:0x65c70ebc441423c0!8m2!3d24.6677442!4d121.8234361!16s%2Fg%2F11gfh3s2pc?hl=zh-TW&entry=ttu"
						>
							<button class="google-map-btn">
								<img src="@/assets/google-map.png" />
								<div>google map</div>
							</button>
						</a> -->
					</div>
					<div
						style="
							display: flex;
							align-items: center;
							font-size: 16px;
							margin-top: 10px;
						"
					>
						<span style="font-size: 16px; margin-right: 8px">●</span>
						搭乘大眾運輸工具
					</div>
					<table class="public-transportation">
						<tr>
							<td
								colspan="2"
								style="
									font-size: 17px;
									color: #f0fbfe;
									background-color: #062b51;
									text-align: center;
									border: 1px solid #fff;
								"
							>
								外縣市至宜蘭
							</td>
						</tr>
						<tr>
							<td style="margin: auto; text-align: center; padding: 0 20px;										white-space: nowrap;height: 100%;vertical-align:middle">
								火車
							</td>
							<td>搭乘至<b>羅東火車站</b>（後站出口），再徒步至<b>羅東轉運站</b>轉搭公車</td>
						</tr>
						<tr>
							<td style="position: relative">
								<div
									style="
										position: absolute;
										top: 50%;
										left: 50%;
										transform: translate(-50%, -50%);
										white-space: nowrap;
									"
								>
									客運
								</div>
							</td>
							<td>
								搭乘客運至<b>羅東轉運站</b>後再轉搭公車至偶戲村<br />
								<ul>
									<li>
										<a href="http://www.capital-bus.com.tw/3.php">首都之星</a
										>：台北<b>【市府轉運站】</b>上車，搭乘往<b>【羅東】</b>班次
									</li>
									<li>
										<a href="https://www.kamalan.com.tw/rline/intro?id=1"
											>噶瑪蘭客運</a
										>：<b>【台北轉運站】</b>上車，搭乘開往<b>【羅東】</b>班次
									</li>
									<li>
										<a
											href="https://www.mtcbus.com.tw/index.php?m=route&a=detail&id=09028"
											>大都會客運</a
										>：<b>【新店-大坪林捷運站】</b>發車，搭乘往<b>【羅東】</b>班次
									</li>
								</ul>
							</td>
						</tr>
					</table>
					<table class="public-transportation">
						<tr>
							<td
								colspan="2"
								style="
									font-size: 17px;
									color: #f0fbfe;
									background-color: #062b51;
									text-align: center;
									border: 1px solid #fff;
								"
							>
								羅東 至 「利澤國際偶戲藝術村」
							</td>
						</tr>
						<tr>
							<td style="position: relative">
								<div
									style="
										position: absolute;
										top: 50%;
										left: 50%;
										transform: translate(-50%, -50%);
										width: 100;
										white-space: nowrap;
									"
								>
									國光客運
								</div>
							</td>
							<td>
								<ul>
									<li>
										<b>國光客運</b>
										<a href="https://www.kingbus.com.tw/page.html?seq=4"
											>乘車路線</a
										>
										（如有變更請以官網為主）
									</li>
									<li>國光客運【1797】羅東－岳明新村路線</li>
									<li>國光客運【1791】羅東 - 南方澳(經清水)路線</li>
									<li>請於<b>【利澤簡站】</b>下車，下車後步行約3-5分鐘即可抵達</li>
								</ul>
							</td>
						</tr>
						<tr>
							<td
								style="
									margin: auto;
									text-align: center;
									padding: 0 35px;
									position: relative;
								"
							>
								<div
									style="
										position: absolute;
										top: 50%;
										left: 50%;
										transform: translate(-50%, -50%);
										width: 100%;
										white-space: nowrap;
									"
								>
									台灣好行
								</div>
							</td>
							<td>
								<ul>
									<li>
										<b>台灣好行</b>
										<a
											href="https://www.taiwantrip.com.tw/Frontend/Route/Select_p?RouteID=R0002"
											>公車時刻表</a
										>
										（如有變更請以官網為主）
									</li>
									<li>台灣好行公車【260冬山河線】運動公園－傳藝中心路線</li>
									<li>請於<b>【利澤老街】</b>站下車，下車後步行約3-5分鐘即可抵達</li>
								</ul>
							</td>
						</tr>
						<tr>
							<td
								style="
									margin: auto;
									text-align: center;
									padding: 0 35px;
									position: relative;
								"
							>
								<div
									style="
										position: absolute;
										top: 50%;
										left: 50%;
										transform: translate(-50%, -50%);
										width: 100%;
										white-space: nowrap;
									"
								>
									計程車
								</div>
							</td>
							<td>
								<ul>
									<li>羅東至偶戲村：車站前常態排班計程車</li>
									<li>單程費用約$200-250不等</li>
								</ul>
							</td>
						</tr>
					</table>
					<div
						style="
							display: flex;
							align-items: center;
							font-size: 16px;
							margin: 30px 0 10px;
						"
					>
						<span style="font-size: 16px; margin-right: 8px">●</span>
						自行開車
					</div>
					<p style="margin: 0">
						1、「國道五號」: 由【羅東.五結】出口下交流道<br />
						2、前往親河路一段（冬山親水公園）:
					</p>
					<p style="margin: 0; margin-left: 15px">
						➜ 沿親河路一段行駛 <br />
						➜ 於「利澤東路」（五結鄉立幼兒園對面）右轉 <br />
						➜ 約100公尺抵達【利澤．國際偶戲藝術村】
					</p>
				</article>
				<article class="map">
					<img src="@/assets/about/traffic/map1.jpg" alt="" />
					<img src="@/assets/about/traffic/map2.jpg" alt="" />
				</article>
			</section>
		</div>
	</div>
</template>

<script>
import PageTitle from "@/components/page_title";

export default {
	metaInfo: {
		title: "利澤國際偶戲藝術村",
	},
	name: "about-report",
	data() {
		return {};
	},
	components: {
		PageTitle,
	},
};
</script>

<style lang="scss" scoped>
b{
	font-weight: 700 !important;
}
.traffic {
	display: flex;
	flex-direction: column;
	margin: auto;

	.message {
		width: 100%;
		padding: 2% 5%;
		max-width: 800px;
		margin:0 auto 50px;
	}
	.map {
		width: 100%;
		padding: 10% 3%;
		background-color: #f4ecd9;
	}
}
.col {
	padding: 0;
}
.row {
	margin: 0;
}

table{
	width: 100%;
}

.community {
	display: flex;
	margin-top: 0;
	margin-bottom: 40px;
	li {
		width: 37px;
		margin-left: 20px;
		img {
			width: 100%;
		}
	}
	li:first-child {
		margin-left: 0px;
	}
}
p {
	line-height: 1.5;
	font-size: 14px;
	font-weight: 400;
}
span {
	line-height: 1.5;
}

h1 {
	font-size: 1.5em;
}

ul {
	list-style-type: disc;
	padding-left: 22px !important;
}

a {
	color: #000;
	text-decoration: underline;
	font-weight: 700;
}

a.button {
	color: #fff;
	border-radius: 100px;
	background: #01b6e2;
	border: none;
	font-size: 1.2em;
	padding: 0.5em 2em;
	margin: 0.5em;
}
.google-map-btn {
	display: flex;
	align-items: center;
	padding: 5px 10px;
	background-color: #eeeeee;
	border-radius: 23px;
	font-size: 12px;
	margin-left: 20px;
	img {
		width: 18.45px;
		margin-right: 5px;
	}
}
.public-transportation {
	margin-top: 20px;
	td {
		font-size: 13.63px;
		line-height: 1.2;
		color: #000;
		background-color: #f0fbfe;
		padding: 14.5px 9px;
		border: 1px solid black;
	}
}

@media screen and (min-width: 768px) {
	.traffic {
		.map{
			padding: 5% 3% 10%;
			display: flex;
			img{
				width: 50%;
			}
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/pages/about/about_report.vue